module.exports = __webpack_public_path__ + "static/pierwsze-kroki-w-CRM-c002b16d8e02a232f03fea14bd94d254.jpg";